import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "popupCloseSmall",
  "use": "popupCloseSmall-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" id=\"popupCloseSmall\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#8c263e\" stroke-linecap=\"square\" stroke-width=\"3\">\n        <path d=\"M18 18l12 12M18 30l12-12\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/popupCloseSmall.svg
// module id = 513
// module chunks = 1